import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenancePageComponent } from './maintenance-page.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MaintenancePageComponent],
  imports: [CommonModule, TranslateModule],
  exports: [MaintenancePageComponent],
})
export class MaintenancePageModule {}
